require('../css/main.scss');

const contactForm = require('./func/contact-index');
const userLang = require('./func/lang-check');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {}
